import React, {FC} from "react";
import {PureButton} from "./BaseButton";
import styled from "styled-components";

const Button = styled(PureButton)`
	font-family: inherit;
	color: ${({theme}) => theme.color.secondary};
`;

export const TextButton: FC<
	React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
> = (props) => {
	return <Button>{props.children}</Button>;
};
